var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1165972",
    "data-name": "Group 1165972",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.296,
    height: 22.296,
    viewBox: "0 0 22.296 22.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.651,8.825A8.825,8.825,0,1,1,8.825,0,8.825,8.825,0,0,1,17.651,8.825Z",
    transform: "translate(1.858 1.858)",
    fill: "none",
    stroke: "#0f1322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.858,1.858,0,0",
    transform: "translate(18.58 18.58)",
    fill: "none",
    stroke: "#0f1322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H22.3V22.3H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.062e13b5e6d0e86e33f3b8bb1ac6ae5c.svg";
export { ForwardRef as ReactComponent };